import { module } from 'modujs';
import { gsap } from 'gsap' ;

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

		this.$collaborators = this.$('collaborator');
		this.circleIteration = 18 ;

		this.bindResize = this.resize.bind(this);
        window.addEventListener("resize", this.bindResize);
    }

	initCircleDisplay() {
		
		this.$collaborators.forEach((item) => {
			let index = parseInt(item.getAttribute('data-index'))
			let x = Math.sin(index * Math.PI * 2 /this.circleIteration) * this.circleSize;
			let y = Math.cos(index * Math.PI * 2 /this.circleIteration) * this.circleSize;

			item.style.transform = `translate3d(${x}px,${y}px,0)`
		});
	}

	ready() {
		this.resize();
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

	resizeDebounce() {
		this.circleSize = (window.innerWidth < window.innerHeight) ? window.innerHeight : window.innerWidth;

		this.initCircleDisplay();
	}
}

